<form (ngSubmit)="submitForm.emit()"
  [formGroup]="form">
  <ng-content></ng-content>
</form>